module.exports = __webpack_public_path__ + "img/cityrama.31a69ec5.jpg";